import { getLang, getTheme, getWindowHeight, getWindowWidth, splitLists, getPosition} from './Helpers/Helpers';

const AnimationEvents = function () {
    "use strict";
    
    this.runBasicEvents = () => {
        let _this = this;
	    
	    
        splitLists();

        $('.fadeBody').click(function() {
	        let attr = $(this).attr('href');
	        if (typeof attr !== typeof undefined && attr !== false) {
		        // $('body').removeClass('fadeIn').addClass('fadeOut');
            }
        });
        
	
	    $(".scroller").click(function (e) {
		    e.preventDefault();
		    
		    let elem = $(this).attr('href');
		    let top;
		    
		   // window.app.nMenu.close();
		    
		    window.app.w > 991 ? top = $(elem).offset().top - $('#s-e-wrapper').outerHeight() : top = $(elem).offset().top;
		    
		    $('html, body').animate({
			    scrollTop: top
		    }, 1000);
	    });
	    
	    $('.oferta__menu__list li a').hover(function(){
	    	$('.offer_' + $(this).data('offer')).addClass('active');
	    },function(){
		    $('.offer-img').removeClass('active');
	    });
	
		this.initMobileChanges();
	
	    window.addEventListener("orientationchange", function(){
		    _this.runOrientationEvents();
        });
	    
	    if (window.app.w < 992){
	    	$('div.submenu').detach().appendTo('#mobileOverlay');
	    	
	    	$('li.hasSubmenu').click(function(){
	    		$('#mobileOverlay').fadeIn();
		    });
		
		    $('#mobileOverlay').click(function(){
			    $(this).fadeOut();
		    });
	    	
	    }
    
        this.setAnimations = function() {
	    	let elems = $('.hasAnimation');
	    	
                elems.each(function(){
                let elem = $(this).offset().top;
        
                let viewportTop = $(window).scrollTop();// + $(window).height();
	               
                if( Math.abs(viewportTop - elem) < getWindowHeight() ){
                    $(this).removeClass('invisible');
                    $(this).addClass($(this).data('ani') + ' animated');
                }
            });
                
                this.scrollChanges();
    
    
        }
    
        this.scrollChanges = function(){
	       
        }
	
	    window.addEventListener("scroll", function(){
            _this.setAnimations();
	    });
    
        window.addEventListener("load", () => {
            _this.setAnimations();
        });
    };
    
    this.initMobileChanges = () => {
	    if (window.app.w < 991){
	    
	    }
	    
    };
    
    this.runOrientationEvents = () => {
        console.log('resize');
    };

    this.showBody = (time) => {
        this.runBasicEvents();
        let message = 'Body Showed';
        // $('body').removeClass('fade-out').addClass('animated fadeIn');

        return this.staticPromise(time, message);
    };

    this.showSliderLabels = (time) => {
	    let message = 'Labels Showed';
        $('.movieHeader').fadeIn('1000');

        return this.staticPromise(time, message);
    };

    this.staticPromise = (time, message) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(message);
            }, time);
        });
    }
    
	
}

let animationEvents = new AnimationEvents();

export { animationEvents };


// WEBPACK FOOTER //
// ./js/core/animationEvents.js